"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Checks if story has a boolean value of isBrandSafe marked by staff
var isBrandSafe_1 = __importDefault(require("./isBrandSafe"));
// Checks if the story is a mature story (contains the mature flag)
var isMatureStory_1 = __importDefault(require("./isMatureStory"));
// checks if brandSafetyLevel is below threshold
// note: This does not fetch the data, it expects the context
// to contain the fetched data
var storyPassesBrandSafetyLevel_1 = __importDefault(require("./storyPassesBrandSafetyLevel"));
// If story is under image mod the story receives no ads
var storyHasImagesUnderModeration_1 = __importDefault(require("./storyHasImagesUnderModeration"));
/**
 * Determine if a story is brand safe for ads based on
 * image moderation, brand safety level, brand safe flag
 * and maturity rating
 */
var isAdvertiserSafe = function (placement, testGroups, context) {
    var storyGroup = context === null || context === void 0 ? void 0 : context.story;
    var storyPart = context === null || context === void 0 ? void 0 : context.storyPart;
    // user is ad exempt check
    if (testGroups.SPECIAL_AD_EXEMPT)
        return { result: false, reason: "skipped_exempt" };
    if (!storyGroup && !storyPart) {
        return { result: true, reason: "passes_all_rules" };
    }
    var story = storyPart ? storyPart : storyGroup;
    // images under moderation check
    if (testGroups.USE_IMAGE_MOD) {
        if (storyGroup && (0, storyHasImagesUnderModeration_1.default)(storyGroup))
            return { result: false, reason: "images_under_moderation" };
        if (storyPart && (0, storyHasImagesUnderModeration_1.default)(storyPart))
            return { result: false, reason: "images_under_moderation" };
    }
    // story brand safety level check
    if (!(0, storyPassesBrandSafetyLevel_1.default)(story))
        return {
            result: false,
            reason: "skipped_brandsafe",
        };
    // is brand safe check
    // only story group has isBrandSafe flag
    if (!(0, isBrandSafe_1.default)(storyGroup))
        return { result: false, reason: "skipped_default" };
    // mature story check
    if (storyGroup && (0, isMatureStory_1.default)(storyGroup))
        return { result: false, reason: "skipped_default" };
    if (storyPart && (0, isMatureStory_1.default)(storyPart))
        return { result: false, reason: "skipped_default" };
    return { result: true, reason: "passes_all_rules" };
};
exports.default = isAdvertiserSafe;
